export class EnumModel {
  constructor(public key: string, public value: string, public displayName?: string) {}
}
